const PersonalizeFooter = () => {
  return (
    <>
      <h5>NOTE</h5>
      <p>
        These questions will help select trials based on their inclusion and exclusion criteria. If you are unsure just press "Not Sure."
        <span>
          {' '}
          <b>You can skip to view trials at any time.</b>
        </span>
      </p>
    </>
  );
};

export default PersonalizeFooter;
